import { Text } from '@medly-components/core';
import { CLEAR_ALL, FILTERS_APPLIED } from 'constants/text/appointment';
import { type FC } from 'react';
import { ClearAllButton, FiltersWrapper } from './AppliedFilters.styled';
import type { AppliedFiltersProps } from './types';

export const AppliedFilters: FC<AppliedFiltersProps> = ({ children, onClearAllFilters, className }) => {
    return (
        <FiltersWrapper className={className}>
            <Text textWeight="Medium">{FILTERS_APPLIED}</Text>
            {children}
            <ClearAllButton onClick={onClearAllFilters}>{CLEAR_ALL}</ClearAllButton>
        </FiltersWrapper>
    );
};

AppliedFilters.displayName = 'AppliedFilters';
